import { render } from "./ChangPassword.vue?vue&type=template&id=28cdac76"
import script from "./ChangPassword.vue?vue&type=script&lang=js"
export * from "./ChangPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__